import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FrontHandIcon(props: IconProps) {
    return <Icon {...props} iconKey={"front_hand"}/>
}
